<template>
  <div
    data-grid="nowrap"
    class="settings__template"
  >
    <SettingsMenu
      :menu-options="menuOptions"
    />

    <div
      class="settings__container"
      data-grid="column"
    >
      <span
        v-if="breadcumb"
        class="breadcumb"
      >
        {{ breadcumb }}
      </span>

      <slot name="form" />
    </div>
  </div>
</template>

<script>
import SettingsMenu from './components/settings-menu'

export default {
  components: {
    SettingsMenu
  },

  props: {
    breadcumb: {
      type: String,
      default: () => ''
    },

    menuOptions: {
      type: Array,
      required: true,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
  .settings__container {
    padding: 36px 25px;
    max-width: 1000px;
    min-height: calc(100vh - 100px);

    .breadcumb {
      margin-bottom: 17px;
      font-size: 11px;
      letter-spacing: .7px;
      text-transform: uppercase;
      color: var(--primary-dark);
    }
  }

  @media (max-width: 1024px) {
    .settings__template {
      flex-flow: column;
    }
  }
</style>
